import { Typography } from "@mui/material";

import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import ReadLogo from "@rui/ReadLogo";
import { Column } from "@rui/Stack";

const MeetingReportNotFound = () => {
  return (
    <Column variant="center" flex={1} spacing={3} sx={{ bgcolor: "#FFF" }}>
      <ReadLogo />
      <Column variant="center" spacing={2} sx={{ maxWidth: "520px" }}>
        <Typography variant="h1" sx={{ fontSize: "2rem" }}>
          This report no longer exists
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          Sorry! This report no longer exists, it may have been deleted by the
          report owner.
        </Typography>
        <Link
          to={ROUTES.MEETING_REPORTS}
          sx={{ fontWeight: 500, color: "shades.primary.500" }}
        >
          Back to Reports
        </Link>
      </Column>
    </Column>
  );
};

export default MeetingReportNotFound;
